export default "__VITE_ASSET__4088dd0e__"